<template>
<div>
    <Header title="专属附件"></Header>
    <van-tabs color="#7181EB" title-active-color="#7181EB" v-model="active" @change="refresh">
        <van-tab :title="item.name" v-for="(item,index) in subjects" :key="index">
        </van-tab>
    </van-tabs>
    <div class="scrollerView" :style="{ height: (wrapperHeight- 105) + 'px' }">
        <scroller :on-refresh="refresh" :on-infinite="infinite" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
            <div class="file-item-wrap" v-for="(item,index) in dataSources" :key="index">
                <div class="item-con-wrap card video" v-if="item.type == 'video'">
                    <div class="item-title-wrap">
                        <p class="title">{{item.name}}</p>
                    </div>
                    <div class="body sub-con-wrap">
                        <video class="video-item w100" :src="item.content"></video>
                    </div>
                </div>
                <div class="item-con-wrap card voice" v-if="item.type == 'audio'">
                    <div class="item-title-wrap">
                        <p class="title">{{item.name}}</p>
                    </div>
                    <div class="body sub-con-wrap">
                        <audio class="audio-item w100" controls>
                            <source :src="item.content">
                        </audio>
                    </div>
                </div>
                <div class="item-con-wrap card article" v-if="item.type == 'article'">
                    <div class="item-title-wrap" @click="_onShowArticle(item)">
                        <p class="title">{{item.name}}</p>
                        <span class="detail-btn-item">查看>></span>
                    </div>
                </div>
            </div>
            <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
        </scroller>
    </div>

    <van-popup v-model="isShowArticle" closeable position="right" :style="{ height: '100%' }">
        <div class="article-wrap" v-html="article"></div>
    </van-popup>

</div>
</template>

<script>
import Lockr from 'lockr'
import Header from '@/components/Header'
export default {
    components: {
        'Header': Header
    },
    data() {
        return {
            loading: true,
            active: 0,
            show: false,
            isShowArticle: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            subjects: [],
            // 列表
            page: 0,
            limit: 10,
            dataSources: [],
            article: '',
        };
    },
    mounted() {
        this.stage_id = this.$route.query.id
        this.requestDataTab();
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    methods: {
        // 请求数据
        async requestDataTab() {
            let url = this.API.my_enroll_subject_detail;
            let params = {
                subject_stage_id: this.stage_id,
                subject_id: ""
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.subjects = result.data.subjects
                this.loading = false
                this.refresh()
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 列表
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(() => {
                this.$refs.infinite && this.$refs.infinite.finishPullToRefresh();
            }, 500)
        },
        infinite() {
            if (!this.loading) {
                this.page++
                this.requestData();
            }
        },
        async requestData() {
            let url = this.API.my_enroll_subject_affix;
            let params = {
                page: this.page,
                limit: this.limit,
                stage_con_id: this.subjects[this.active] && this.subjects[this.active].id
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let list = result.data || []
                if (this.page === 1) {
                    this.dataSources = list
                } else {
                    this.dataSources = this.dataSources.concat(list)
                }
                this.$refs.infinite && this.$refs.infinite.finishInfinite(list.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        showPopup() {
            this.show = !this.show
        },
        // 顶部Nav的跳转
        onPressNav(router) {
            this.$router.push({
                path: '/' + router,
                query: {}
            })
        },
        _onShowArticle(item) {
            this.article = item.content;
            this.isShowArticle = true;
        }
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}

.class-title {
    height: 40px;
    padding: 0 15px;
    background: #fff;
    font-size: 15px;
    color: #333;
    line-height: 44px;
    font-weight: 500;
}

.file-item-wrap {
    .item-con-wrap {
        margin: 1rem 1rem;
        background: #fff;
        border-radius: .5rem;

        .item-title-wrap {
            display: flex;
            align-items: center;

            .title {
                flex: 1;
                height: 40px;
                padding: 0 15px;
                font-size: 15px;
                color: #333;
                line-height: 40px;
            }

            .detail-btn-item {
                margin: 0 15px;
                color: #7181EB;
            }
        }
    }

    .video {
        .sub-con-wrap {
            padding: 1rem 1rem;

            .video-item {
                border-radius: .5rem;
            }
        }
    }

    .voice {
        padding-bottom: 10px;

        .sub-con-wrap {
            padding: 1rem 1rem;

            .video-item {
                border-radius: .5rem;
            }

            .play {
                width: 38px;
                height: 38px;
            }

            p {
                margin-left: 10px;
                font-size: 14px;
                color: #333;
            }

            .van-slider {
                margin-left: 20px;
                flex: 1;
            }

            .icon {
                margin-left: 20px;
                width: 20px;
                height: 15px;
            }
        }

        div {}
    }

    .article {}
}

.article-wrap {
    padding: 4rem 1rem 1rem;
}
</style>
